import { indicar_ensino_fase_concluida } from "./indicar-ensino-fase-concluida";

const correcao_de_fluxo = [...indicar_ensino_fase_concluida];

export { correcao_de_fluxo };
